import React, { useRef, useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { withWindowSizeListener } from 'react-window-size-listener'
import '../styles/components/MenuOption.css'

const MenuOption = ({ children, icon, path, hasContent, windowSize: { windowWidth } }) => {
  const history = useHistory()

  const [optionWidth, setOptionWidth] = useState(0)
  const optionRef = useRef(null)

  /*
    listen the window width, when the window width changes, update
    the option box width to calculate the new height based on the new width

    obs: similar to aspect-ratio property
  */
  useEffect(() => {
    setOptionWidth(optionRef.current.offsetWidth)
  }, [windowWidth])

  return (
    <div ref={optionRef} onClick={() => history.push(path)} className='menu-option'
      style={{ height: 2 * optionWidth / 3 }}>
      {hasContent ? (
        <div className='menu-option-notification' />
      ) : false}
      <img src={icon} alt='icon' />
      {children}
    </div>
  )
}

export default withWindowSizeListener(MenuOption)



// WEBPACK FOOTER //
// ./src/components/MenuOption.js